import IframeModal from './IframeModal.jsx'

export default IframeModal
